import { alpha, Box, Typography } from '@mui/material';
import React from 'react';
import I18n from '../../../../i18n/I18n';
import { Icons } from '../../../../icons/Icons';
import type { ShareAccessLevel } from '../../../types';

type ShareAccessLevelLabelProps = {
    accessLevel: ShareAccessLevel;
    isButtonLabel?: boolean;
};

const RESTRICTED_CONFIG = {
    labelToken: 'common.share.scope.restricted',
    descriptionToken: 'common.share.scope.restrictedDescription',
    Icon: Icons.Lock
};

const OPEN_CONFIG = {
    labelToken: 'common.open',
    descriptionToken: 'common.share.scope.org',
    Icon: Icons.Unlock
};

export default function ShareAccessLevelLabel({ accessLevel, isButtonLabel = false }: ShareAccessLevelLabelProps) {
    const config = accessLevel === 'restricted' ? RESTRICTED_CONFIG : OPEN_CONFIG;

    return (
        <Box sx={{ display: 'flex', gap: 1 }}>
            <Box
                sx={(theme) => ({
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    borderRadius: '50%',
                    bgcolor: alpha(theme.palette.primary.main, 0.08),
                    width: 40,
                    height: 40,
                    minWidth: 40,
                })}
            >
                <config.Icon sx={{ fontSize: 25, color: 'primary.main' }} />
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 0.25 }}>
                <Box sx={{ display: 'flex', gap: 0.5, flexWrap: 'wrap', alignItems: 'center' }}>
                    <Typography sx={{ fontSize: { xs: '14px', md: '16px' }, color: 'text.primary' }}>
                        <I18n token={config.labelToken} />
                    </Typography>
                    {isButtonLabel && <Icons.ArrowDropDownOutlined sx={{ fontSize: 16, color: 'text.secondary' }} />}
                </Box>
                <Typography
                    sx={{
                        fontWeight: 'subtitle2.fontWeight',
                        color: 'text.disabled',
                        textAlign: 'left'
                    }}
                >
                    <I18n token={config.descriptionToken} />
                </Typography>
            </Box>
        </Box>
    );
}
